/* PISOS MANRIQUEZ - Microinteracciones. InProject Solutions v1.0 */
(function () {
  'use strict';

  if (window.__pmRedesignReady) return;
  window.__pmRedesignReady = true;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Reveal on scroll */
  function initReveal(root) {
    var items = (root || document).querySelectorAll('.pm-reveal:not([data-pm-obs])');
    if (!items.length) return;
    if (reduced || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(items, function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-pm-delay') || '0', 10);
        setTimeout(function () { el.classList.add('is-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(items, function (el) {
      el.setAttribute('data-pm-obs', '1');
      io.observe(el);
    });
  }

  /* 2. Contadores */
  function initCounters(root) {
    var nodes = (root || document).querySelectorAll('[data-pm-count]:not([data-pm-counted])');
    if (!nodes.length) return;

    function run(el) {
      el.setAttribute('data-pm-counted', '1');
      var target = parseFloat(el.getAttribute('data-pm-count')) || 0;
      var suffix = el.getAttribute('data-pm-suffix') || '';
      if (reduced) { el.textContent = target + suffix; return; }
      var t0 = null, dur = 1500;
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }

    if (!('IntersectionObserver' in window)) { Array.prototype.forEach.call(nodes, run); return; }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { run(e.target); io.unobserve(e.target); } });
    }, { threshold: 0.4 });
    Array.prototype.forEach.call(nodes, function (el) { io.observe(el); });
  }

  /* 3. Carruseles */
  function initCarousels(root) {
    var carousels = (root || document).querySelectorAll('[data-pm-carousel]:not([data-pm-car-init])');
    Array.prototype.forEach.call(carousels, function (car) {
      car.setAttribute('data-pm-car-init', '1');
      var vp = car.querySelector('[data-pm-viewport]');
      if (!vp) return;
      var scope = car.closest('section') || document;
      var prev = scope.querySelector('[data-pm-prev]');
      var next = scope.querySelector('[data-pm-next]');

      function amount() {
        var first = vp.firstElementChild;
        if (!first) return vp.clientWidth * 0.8;
        var cs = getComputedStyle(vp);
        var gap = parseFloat(cs.columnGap || cs.gap || '16') || 16;
        return (first.getBoundingClientRect().width + gap) * 2;
      }
      function sync() {
        if (!prev || !next) return;
        var max = vp.scrollWidth - vp.clientWidth - 2;
        prev.disabled = vp.scrollLeft <= 2;
        next.disabled = vp.scrollLeft >= max;
      }
      if (prev) prev.addEventListener('click', function () { vp.scrollBy({ left: -amount(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { vp.scrollBy({ left: amount(), behavior: 'smooth' }); });
      vp.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  /* 4. Marquee: duplica el track para loop continuo */
  function initMarquee(root) {
    var tracks = (root || document).querySelectorAll('[data-pm-marquee]:not([data-pm-mq-init])');
    Array.prototype.forEach.call(tracks, function (track) {
      track.setAttribute('data-pm-mq-init', '1');
      track.innerHTML = track.innerHTML + track.innerHTML;
      var width = track.scrollWidth / 2;
      var dur = Math.max(18, Math.round(width / 60));
      track.style.animationDuration = dur + 's';
    });
  }

  /* 5. Cotizador -> WhatsApp */
  function initQuoteForms(root) {
    var forms = (root || document).querySelectorAll('[data-pm-quote]:not([data-pm-quote-init])');
    Array.prototype.forEach.call(forms, function (form) {
      form.setAttribute('data-pm-quote-init', '1');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!form.reportValidity()) return;

        var wa = (form.getAttribute('data-wa') || '').replace(/[^0-9]/g, '');
        var get = function (n) { var f = form.querySelector('[name="' + n + '"]'); return f ? f.value : ''; };
        var cat = get('categoria'), m2 = get('m2'), tel = get('telefono');

        var lines = ['Hola Pisos Manriquez, quiero cotizar:'];
        if (cat) lines.push('- Categoria: ' + cat);
        if (m2) lines.push('- m2 aproximados: ' + m2);
        if (tel) lines.push('- Mi telefono: ' + tel);
        lines.push('(Enviado desde la web)');

        var hook = form.getAttribute('data-webhook');
        if (hook) {
          try {
            fetch(hook, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ categoria: cat, m2: m2, telefono: tel, origen: 'home-cotizador', ts: new Date().toISOString() }),
              keepalive: true
            })['catch'](function () {});
          } catch (err) {}
        }

        window.open('https://wa.me/' + wa + '?text=' + encodeURIComponent(lines.join('\n')), '_blank', 'noopener');
      });
    });
  }

  function boot(root) {
    initReveal(root);
    initCounters(root);
    initCarousels(root);
    initMarquee(root);
    initQuoteForms(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
